import React from 'react';
import cs from 'classnames';
import { SliderItem } from 'react-compound-slider';
import { GetHandleProps } from 'react-compound-slider/dist/types/Handles/types';

const HandleWithValue: React.FC<{
  min: number;
  max: number;
  handle: SliderItem;
  disabled: boolean;
  getHandleProps: GetHandleProps;
  valueDisplayMap?: Record<number, string>;
}> = ({ min, max, handle: { id, value, percent }, disabled = false, getHandleProps, valueDisplayMap }) => (
  <>
    <div
      role="slider"
      className={cs('slider__handle-pointer', {
        'slider__handle-pointer--disabled': disabled,
      })}
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      style={{
        left: `${percent}%`,
      }}
      {...getHandleProps(id)}
    >
      <div className="slider__handle-value">{valueDisplayMap ? valueDisplayMap[value] : value}</div>
    </div>
  </>
);

export default HandleWithValue;
